module.exports = __webpack_public_path__ + "img/IBMSmartCampLogo.1dbb7a00.png";